import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Modal.module.postcss';

function Modal({ children, contentClassName, allowOverflow = false }) {
  return (
    <div className={styles.ModalContainer}>
      <div className={cn(styles.ModalContent, contentClassName, {
        [styles.ModalContent__allowOverflow]: allowOverflow,
      })}>
        {children}
      </div>
    </div>
  );
}

Modal.propTypes = {
  children: PropTypes.node,
  contentClassName: PropTypes.string,
  allowOverflow: PropTypes.bool,
};

export default Modal;
